import { Component } from 'react';
import Link from 'next/link';
import Img from 'react-image';
import styled from 'styled-components';
import { faUsers, faBirthdayCake } from '@fortawesome/fontawesome-free-solid';

import StyledText from '../shared/StyledText';
import IconWithLabel from '../shared/IconWithLabel';
import { MEDIUM_TEXT, SMALL_TEXT } from '../../constants';
import { GameType } from '../types';
import { withI18next } from '../../lib/withI18next';
import getCurrentLang from '../../lib/getCurrentLang';
import env from '../../lib/env';

const Container = styled.div`
  cursor: pointer;
`;

const Image = styled(Img)`
  background: #f4f4f4;
  width: 100%;
  border-radius: 25px;
  border: transparent 2px solid;

  &:hover {
    opacity: 0.8;
    border: grey 2px solid;
    transition: 0.2s ease;
  }
`;

class Card extends Component {
  render() {
    const {
      game: { id, short_descr, title, min_age, min_players },
      t,
      i18n,
    } = this.props;

    const tempPlayerLabel =
      min_players <= 1
        ? `${t('COMPONENTS_SHARED_GAME_PLAYERS_SINGULAR')}`
        : `${t('COMPONENTS_SHARED_GAME_PLAYERS_PLURAL')}`;
    const numberOfPlayersLabelText = `${t(
      'COMPONENTS_SHARED_GAME_FROM'
    )} ${min_players} ${tempPlayerLabel}`;

    if (id === null || title === null || short_descr === null) return null;
    const currentLang = getCurrentLang(i18n).value;

    return (
      <Link
        href={`{/game?id=${id}?lng=${currentLang}`}
        as={`/game/${id}?lng=${currentLang}`}
      >
        <Container>
          <Image
            src={`${env.S3_ENDPOINT}/details/${id}-detail.jpg`}
            alt={title}
          />
          <StyledText size={MEDIUM_TEXT} isBold>
            {title}
          </StyledText>
          <StyledText size={SMALL_TEXT}>{short_descr}</StyledText>
          {min_players !== null ? (
            <IconWithLabel label={numberOfPlayersLabelText} icon={faUsers} />
          ) : null}
          {min_age !== null ? (
            <IconWithLabel label={`${min_age}+`} icon={faBirthdayCake} />
          ) : null}
        </Container>
      </Link>
    );
  }
}

Card.propTypes = {
  game: GameType,
};

export default withI18next()(Card);



// WEBPACK FOOTER //
// components/GameCards/Card.js